import type HighchartsType from 'highcharts/highstock';

import type { FullscreenRuntimeChart } from './fullScreenChartTypes';

export const applyFullscreenRangeSelectorLayout = (chart: HighchartsType.Chart): void => {
  const rangeSelector = (chart as FullscreenRuntimeChart).rangeSelector;
  if (!rangeSelector) return;
  rangeSelector.zoomText?.hide();
  rangeSelector.positionButtons?.();
};

export const installFullscreenRangeSelectorSync = (chart: HighchartsType.Chart): void => {
  const rangeSelector = (chart as FullscreenRuntimeChart).rangeSelector;
  if (!rangeSelector?.render || rangeSelector.fullscreenRangeSelectorSyncInstalled) return;

  const render = rangeSelector.render.bind(rangeSelector);
  rangeSelector.render = (min, max) => {
    render(min, max);
    applyFullscreenRangeSelectorLayout(chart);
  };
  rangeSelector.fullscreenRangeSelectorSyncInstalled = true;
};
